export class SlideshowTitleStyle {
  size = '';
  color = '';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<SlideshowTitleStyle>): SlideshowTitleStyle {
    const pureStyles = new SlideshowTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
